export default __webpack_public_path__ + "static/media/imgs8.23c9ba5c.jpg";